export default __webpack_public_path__ + "static/media/Add.4f75adbb.svg";